var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlightActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.092 29.238l22.536-11.189c1.52-.751 3.37-.2 4.22 1.26.98 1.683.228 3.836-1.59 4.557l-25.093 9.886a2.405 2.405 0 01-2.434-.394l-4.726-3.982a.798.798 0 01.26-1.367l3.032-1.034a.815.815 0 01.73.103l3.065 2.16z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.092 29.238l22.536-11.189c1.52-.751 3.37-.2 4.22 1.26.98 1.683.228 3.836-1.59 4.557l-25.093 9.886a2.405 2.405 0 01-2.434-.394l-4.726-3.982a.798.798 0 01.26-1.367l3.032-1.034a.815.815 0 01.73.103l3.065 2.16z",
    stroke: "#008CFF",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.671 24.898l-5.492-2.71a.798.798 0 01-.03-1.418l1.849-1.013c.36-.197.785-.249 1.182-.141l8.456 2.277-5.965 3.005z",
    fill: "#A9D4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.671 24.898l-5.492-2.71a.798.798 0 01-.03-1.418l1.849-1.013c.36-.197.785-.249 1.182-.141l8.456 2.277-5.965 3.005z",
    stroke: "#008CFF",
    strokeWidth: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.856 29.34l-.896 6.179c-.094.644.588 1.124 1.17.826l2.417-1.242c.366-.188.644-.508.78-.894l2.534-7.279-6.005 2.41z",
    fill: "#A9D4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.856 29.34l-.896 6.179c-.094.644.588 1.124 1.17.826l2.417-1.242c.366-.188.644-.508.78-.894l2.534-7.279-6.005 2.41z",
    stroke: "#008CFF",
    strokeWidth: 1.44
  }))));
}
export default SvgFlightActive;